import React, {useContext, useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import CheckoutCotizarHogar from "../components/Formularios/CombinadoForm";
import CheckoutCotizarVehiculo from "../components/Formularios/VehiculoForm";
import CheckoutCotizarMicroseguros from "../components/Formularios/MicrosegurosForm";
import {ReactComponent as LeftArrow} from '../assets/systemIcons/left-arrow.svg'
import CheckoutCotizarMotovehiculo from "../components/Formularios/MotovehiculoForm";
import CheckoutCotizarAsistenciaViajero from "../components/Formularios/AsistenciaViajeroForm";
import ClienteDirectoContext from "../context/ClienteDirectoContext";
import CompanyLogo from "../components/CompanyLogo/CompanyLogo";
import AccordionDetails from "../components/AccordionDetails";

const microsegurosDict = {
    "robosvarios": 26,
    "bicicleta": 48,
    "monopatin": 48,
    "tablet": 37,
    "notebook": 36
}

const getForm = (producto, steps, activeStep, setActiveStep) => {
    switch (producto) {
        case 'automotor':
            return <CheckoutCotizarVehiculo steps={steps} activeStep={activeStep} setActiveStep={setActiveStep}/>
        case 'motovehículo':
            return <CheckoutCotizarMotovehiculo steps={steps} activeStep={activeStep} setActiveStep={setActiveStep}/>
        case 'hogar':
            return <CheckoutCotizarHogar steps={steps} activeStep={activeStep} setActiveStep={setActiveStep}/>
        case 'asistenciaviajero':
            return <CheckoutCotizarAsistenciaViajero steps={steps} activeStep={activeStep}
                                                     setActiveStep={setActiveStep}/>
        default:
            return <CheckoutCotizarMicroseguros
                pickedCobertura={microsegurosDict[producto]} steps={steps} activeStep={activeStep}
                setActiveStep={setActiveStep}/>
    }
};

const handleNavigateToBaseUrl = (navigate) => {
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('/').slice(0, 4).join('/');
    navigate(baseUrl.replace(window.location.origin, ""));
};

const productoMap = {
    automotor: 'vehiculo',
    asistenciaviajero: 'asistencia_viajero',
    motovehículo: 'motovehiculo',
    bicicleta: 'microseguros',
    monopatin: 'microseguros',
    notebook: 'microseguros',
    tablet: 'microseguros',
    robosvarios: 'microseguros'
};

const stepsMap = {
    vehiculo: ["Vehículo", "¡Elegí tu plan!", "Titular", "Póliza", "Resumen"],
    motovehiculo: ["Vehículo", "¡Elegí tu plan!", "Titular", "Póliza", "Resumen"],
    hogar: ['Información', 'Coberturas', 'Resumen', 'Cliente', 'Póliza', 'Solicitud'],
    asistencia_viajero: ["Viaje", "¡Elegí tu plan!", "Titular", "Póliza", "Resumen"],
    microseguros: ['Información', 'Coberturas', 'Resumen', 'Cliente', 'Póliza', 'Solicitud'],
};

function Formularios() {
    const params = useParams();
    const navigate = useNavigate();
    const {activeProducts, companiesIdDict} = useContext(ClienteDirectoContext);
    const [companiesName, setCompaniesName] = useState([]);
    const [activeStep, setActiveStep] = useState(0);

    const productoMaped = productoMap[params['producto']] || params['producto'];
    const steps = stepsMap[productoMaped] || stepsMap['microseguros'];
    const currentStepName = steps[activeStep];

    useEffect(() => {
            window.scrollTo({top: 0, behavior: "smooth"});
        }, [activeStep])

    useEffect(() => {
        const codigosAseguradoras = activeProducts[productoMaped].codigos_aseguradoras;
        const companiesId = Array.from(
            new Set(codigosAseguradoras.map(el => el['id_aseguradora']))
        );
        const companiesName = companiesId.map(id => companiesIdDict[id]);
        setCompaniesName(companiesName);
    }, [params]);

    return (
        <div className="form">
            <section className="navbar__navigation">
                <nav onClick={() => handleNavigateToBaseUrl(navigate)}>
                    <div className="navbar__circle">
                        <LeftArrow className="navbar__icon"/>
                    </div>
                    <p className="navbar__text">Atrás</p>
                </nav>
            </section>
            {(currentStepName === "¡Elegí tu plan!" || currentStepName === "Coberturas") && (
                <AccordionDetails product={params['producto']}/>
            )}
            <section className="form__box">
                {getForm(params['producto'], steps, activeStep, setActiveStep)}
            </section>
            {activeStep === 0 &&
                <section className="formCompanies__container">
                    <p className="formCompanies__title">Estás cotizando con las siguientes compañías</p>
                    <div className="formCompanies__companiesContainer">
                        {companiesName.map((company) => (
                            <div className="companies__company">
                                <CompanyLogo company={company}/>
                            </div>
                        ))}
                    </div>
                </section>
            }
        </div>
    );
}

export default Formularios;